let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("86z6R")).then(() => parcelRequire('5fVTA'));